import React, { createContext, useContext, ReactNode } from 'react';

type PageTitleContextType = {
    customPageTitle: ReactNode | null;
    setCustomPageTitle: (element: ReactNode | null) => void;
};

// eslint-disable-next-line react-refresh/only-export-components
export const PageTitleContext = createContext<PageTitleContextType | undefined>(undefined);

export const PageTitleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [customPageTitle, setCustomPageTitle] = React.useState<ReactNode | null>(null);

    return <PageTitleContext.Provider value={{ customPageTitle, setCustomPageTitle }}>{children}</PageTitleContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const usePageTitle = () => {
    const context = useContext(PageTitleContext);
    if (!context) {
        throw new Error('usePageTitle must be used within a PageTitleProvider');
    }
    return context;
};
